import API from "../api";

export const getAgencyInfo = agency_code => {
  return API.agency().get(`/agency/${agency_code}`);
};
